import React from 'react'
import Default from './default'

const View = (props) => {
	const {
		authorizationRequired,
		content,
		exact,
		isAuthorizedRedirect,
		htmlTagClassName,
		location,
		metaDescription,
		pageTitle,
		path,
		RenderDefault,
	} = props

	return (
		<RenderDefault
			authorizationRequired={authorizationRequired}
			content={content}
			exact={exact}
			isAuthorizedRedirect={isAuthorizedRedirect}
			htmlTagClassName={htmlTagClassName}
			location={location}
			metaDescription={metaDescription}
			pageTitle={pageTitle}
			path={path}
		/>
	)
}

View.defaultProps = {
	RenderDefault: Default,
}

export default View


// WEBPACK FOOTER //
// ./src/common/components/route-with-auth/view.js